import { toUrlParams } from '@anm/helpers/parseParams';

import vtConfig from '../../config';

const { urls } = vtConfig();

type EditorTarget = 'edit' | 'uploads' | 'stock-library';
export type EditorUrlParams = {
  format?: string;
  target?: EditorTarget;
  folderId?: number | null;
};
export type EditorActionParams = {
  p?: string;
  r?: string;
  new?: string;
};
const getEditorUrl = (actionParam: EditorActionParams) => (
  additionalParams: EditorUrlParams = {}
) => {
  const params = `${toUrlParams({ ...actionParam, ...additionalParams })}`;

  return `${urls.editor}/#${params}`;
};

export const edit = (projectId: string, params?: EditorUrlParams) => {
  window.open(getEditorUrl({ p: projectId })(params));
};
